import { useEffect } from "react";
import { useSession } from "../lib/session.tsx";
import { setAnalyticsUser } from "../lib/analytics.ts";

/**
 * No-render component — reads the shared session and attaches user identity to
 * every subsequent GA4 event. Place inside <SessionProvider> so it never
 * triggers a new /get-session fetch.
 */
export function AnalyticsIdentity() {
  const { data } = useSession();

  useEffect(() => {
    setAnalyticsUser(data?.user?.id ?? null, data?.session?.activeOrganizationId ?? null);
  }, [data?.user?.id, data?.session?.activeOrganizationId]);

  return null;
}
